/**
 * Browser module - Browser-only adapters
 *
 * Logic shared by both React apps and the bundled widget.
 * Explicitly browser-only - uses window, document, cookies, localStorage, fetch.
 *
 * Do not import from server-only code.
 */

// Constants
export { STORAGE_KEYS, COLORS, TYPOGRAPHY, APP_TYPES } from './constants';

// Storage
export { getStoredEmail, setStoredEmail, clearStoredEmail } from './storage';

// Snowplow identity
export {
  configureVisitorIdentity,
  deferVisitorIdentity,
  identifyVisitorByEmail,
} from './identity';

// Analytics
export { sendEvent, configureAnalytics } from './send-event';
export {
  trackFormFailedToDisplay,
  trackFormOpen,
  trackFormOpenEmailPrefilled,
  trackFormMouseover,
  trackFormStartedEmailBoxClick,
  trackFormStartedEmailBoxType,
  trackFormFailedSubmit,
  trackFormSubmitted,
  trackMicroDataQuestionDisplayed,
  trackMicroDataQuestionSubmitted,
  trackMicroDataQuestionFailedSubmit,
  trackFormClosed,
} from './analytics';

// Client data collection
export {
  getCookie,
  getDataFromUrl,
  getClientFields,
  getPageParams,
  getContextParams,
  getProductParams,
  getPageCategoryDefaultValue,
  collectClientData,
} from './client-data';

// Gateway submission
export { submitToGateway, createGatewaySubmitAction } from './submission';
